import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, resolveDynamicComponent as _resolveDynamicComponent, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, openBlock as _openBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "block-viewer__container"
}

import StoryPopup from "@/components/Home/Content/Story/StoryPopup.vue";
import {nextTick, onMounted, onUnmounted, ref} from "vue";
import type { Component } from "vue";
import 'swiper/css';
import 'swiper/css/pagination';
import BlockViewer from "@/ts/User/BlockViewer";

export default /*@__PURE__*/_defineComponent({
  __name: 'BlockViewer',
  setup(__props) {

const container = ref<HTMLDivElement>()
const popup = ref<StoryPopup>()

const showedPopup = ref(false)
const blockComponent = ref<Component | null>(null)
const blockProps = ref<Record<string, any>>({})
let viewer: BlockViewer;

onMounted(() => {
  const viewer = BlockViewer.getInstance()
  viewer.addOnShowListener(async () => {
    container.value!.classList.add('active')
    showedPopup.value = false
    await nextTick()
    showedPopup.value = true
  })
  viewer.init(container.value!, blockComponent, blockProps)
})
const onClose = () => {
  setTimeout(() => {
    showedPopup.value = false
  }, 500)
}
onUnmounted(() => {
  showedPopup.value = false
  viewer?.destroy()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "container",
    ref: container,
    class: "block-viewer"
  }, [
    (showedPopup.value)
      ? (_openBlock(), _createBlock(StoryPopup, {
          key: 0,
          ref_key: "popup",
          ref: popup,
          onClose: onClose
        }, {
          default: _withCtx(({hide}) => [
            (blockComponent.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                  _createTextVNode(_toDisplayString(blockProps.value) + " ", 1),
                  (_openBlock(), _createBlock(_resolveDynamicComponent(blockComponent.value!), _normalizeProps(_guardReactiveProps(blockProps.value)), null, 16))
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 512))
      : _createCommentVNode("", true)
  ], 512))
}
}

})